import React from "react";
import { addFlashAlert } from "common/components/FlashAlert";
import { DropdownOption } from "common/components/DropdownMenu";
import { FileWithPreview } from "common/types";
import { OptionButton } from "common/components/DropdownMenu/OptionButton";
import Files from "react-files";

interface FilesOptionButtonProps {
  index: number;
  option: DropdownOption;
  onFileChange: (files: FileWithPreview[], option: DropdownOption) => void;
}
export const FilesOptionButton: React.FC<FilesOptionButtonProps> = ({ index, option, onFileChange }) => {
  const onFilesError = (error: any) => {
    addFlashAlert("danger", error.message);
  };

  const handleFileChange = (files: FileWithPreview[]) => {
    onFileChange(files, option);
  };

  return (
    <Files
      onChange={handleFileChange}
      onError={onFilesError}
      accepts={[".pdf", ".html"]}
      multiple
      maxFileSize={30000000}
      minFileSize={0}
      clickable>
      <OptionButton index={index} option={option} />
    </Files>
  );
};
